import { Link } from 'react-router-dom';

interface GameCardProps {
  id: number;
  title: string;
  slug: string;
  category: string;
  categoryName: string;
  image: string;
  rating: number;
  players: string;
}

export default function GameCard({ id, title, slug, category, categoryName, image, rating, players }: GameCardProps) {
  return (
    <Link
      to={`/category/${category}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[4/3] overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={`${title} - 黄油网页游戏`}
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-primary-600 rounded-full whitespace-nowrap">
            {categoryName}
          </span>
        </div>
        <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-50/90 backdrop-blur-sm px-2 py-0.5 rounded-full">
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
          </div>
          <span className="text-xs font-semibold text-foreground-800">{rating}</span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors mb-2 whitespace-nowrap overflow-hidden text-ellipsis">
          {title}
        </h3>
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-user-line"></i>
            </div>
            {players} 玩家
          </span>
        </div>
      </div>
    </Link>
  );
}